import * as React from 'react';
import {
  createBrowserRouter,
} from 'react-router-dom';
// import CNF from './Config.js';

 /*** 引入路由界面 ***/  
 import Error404 from './Error404.js';
 import App from '../App.js';
 import Dashboard from '../components/dashboards/Dashboard.js';
 import Aim from '../Aim.js';
  /*** 引入路由界面 ***/ 

 const BasicRouter = createBrowserRouter([
	{
		path: '/',
		element: <Dashboard />,
		errorElement: <Error404/>,
	},{
		path: '/setting/areas',
		element: <App m={11}/>,
		errorElement: <Error404/>,
	},{
		path: '/intersections',
		element: <App m={21}/>,
		errorElement: <Error404/>,
	},{
		path: '/intersection/timings',
		element: <App m={22}/>,
		errorElement: <Error404/>,
	},{
		path: '/intersection/images',
		element: <App m={23}/>,
		errorElement: <Error404/>,
	},{
		path: '/walkways',
		element: <App m={24}/>,
		errorElement: <Error404/>,
	},{
		path: '/walkway/images',
		element: <App m={25}/>,
		errorElement: <Error404/>,
	},{
		path: '/lines',
		element: <App m={31}/>,
		errorElement: <Error404/>,
	},{
		path: '/line/infos',
		element: <App m={32}/>,
		errorElement: <Error404/>,
	},{
		path: '/line/aims',
		element: <Aim m={3}/>,
		errorElement: <Error404/>,
	},{
		path: '/vs/devlss',
		element: <App m={41}/>,
		errorElement: <Error404/>,
	},{
		path: '/report/intersection/idhmc',
		element: <App m={51}/>,
		errorElement: <Error404/>,
	},{
		path: '/report/intersection/idinc',
		element: <App m={52}/>,
		errorElement: <Error404/>,
	},{
		path: '/report/intersection/iddec',
		element: <App m={53}/>,
		errorElement: <Error404/>,
	},{
		path: '/report/intersection/idrec',
		element: <App m={54}/>,
		errorElement: <Error404/>,
	},{
		path: '/report/intersection/idstc',
		element: <App m={55}/>,
		errorElement: <Error404/>,
	},{
		path: '/report/intersection/ityec',
		element: <App m={56}/>,
		errorElement: <Error404/>,
	},{
		path: '/report/intersection/idopc',
		element: <App m={57}/>,
		errorElement: <Error404/>,
	},{
		path: '/log/operations',
		element: <App m={61}/>,
		errorElement: <Error404/>,
	},{
		path: '/log/timings',
		element: <App m={62}/>,
		errorElement: <Error404/>,
	},
]);

export default BasicRouter